<template>
  <b-tag :style="{ 'background-color': data.color }">
    <strong>{{ data.name }}</strong>
  </b-tag>
</template>

<script>
export default {
  name: 'NewsCategoryTag',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style>
</style>
